export const adminState = {
    vaultUsers: [],
};
